import BaseStore from "@/v1/utils/BaseStore";

const initialState = baseState => ({
  ...baseState,
  filters: [
    {
      key: "type",
      title: "label.type",
      icon: "type",
      active: false,
      values: [],
      metadata: [],
    },
  ],
});
const store = new BaseStore("gameCategories", initialState);
const reducer = {};

export default store.reducer(reducer);
